import React, { useState } from "react";
import { motion } from "framer-motion";

const floorPlans = [
  {
    id: 1,
    name: "Magnolia Villa",
    image:
      "/Images/RIVERA_THE_VALLEY_IMAGE02.jpg",
    areas: [
      { name: "Master Bedroom", x: 20, y: 30 },
      { name: "Living Room", x: 60, y: 50 },
      { name: "Kitchen", x: 75, y: 75 },
    ],
  },
  {
    id: 2,
    name: "Lotus Villa",
    image:
      "/Images/RIVERA_THE_VALLEY_IMAGE07.jpg",
    areas: [
      { name: "Master Bedroom", x: 25, y: 25 },
      { name: "Living Room", x: 55, y: 55 },
      { name: "Terrace", x: 80, y: 30 },
    ],
  },
  {
    id: 3,
    name: "Lavender Villa",
    image:
      "/Images/RIVERA_THE_VALLEY_IMAGE13.jpg",
    areas: [
      { name: "Master Bedroom", x: 30, y: 20 },
      { name: "Living Room", x: 50, y: 60 },
      { name: "Garden View", x: 85, y: 40 },
    ],
  },
];

const FloorPlanSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeArea, setActiveArea] = useState(null);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % floorPlans.length);
    setActiveArea(null);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + floorPlans.length) % floorPlans.length
    );
    setActiveArea(null);
  };

  return (
    <div className="relative bg-white rounded-xl overflow-hidden">
      <div className="relative aspect-w-16 aspect-h-12">
        <img
          src={floorPlans[currentIndex].image}
          alt={floorPlans[currentIndex].name}
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 bg-midnightBlack/10"></div>

        {/* Area Markers */}
        {floorPlans[currentIndex].areas.map((area, index) => (
          <motion.div
            key={index}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: index * 0.2 + 0.3 }}
            className="absolute"
            style={{ left: `${area.x}%`, top: `${area.y}%` }}
          >
            <div
              className={`cursor-pointer group`}
              onMouseEnter={() => setActiveArea(area.name)}
              onMouseLeave={() => setActiveArea(null)}
            >
              <div
                className={`w-4 h-4 rounded-full ${
                  activeArea === area.name ? "bg-gold-400" : "bg-gold-300"
                } relative animate-pulse-slow`}
              >
                <div className="absolute -inset-1 rounded-full bg-gold-200 opacity-60 animate-ping"></div>
              </div>
              <div
                className={`
                absolute bottom-full left-1/2 transform -translate-x-1/2 -translate-y-1 
                bg-midnightBlack text-white text-xs font-medium py-1 px-2 rounded-md whitespace-nowrap
                transition-opacity duration-200 pointer-events-none
                ${activeArea === area.name ? "opacity-100" : "opacity-0"}
              `}
              >
                {area.name}
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-px border-t-4 border-l-4 border-r-4 border-transparent border-t-midnightBlack"></div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-midnightBlack/70 to-transparent p-4 flex justify-between items-end">
        <div>
          <h3 className="text-white font-semibold">
            {floorPlans[currentIndex].name}
          </h3>
          <p className="text-white/80 text-sm">Floor plan visualization</p>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={handlePrev}
            className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/40 flex items-center justify-center transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button
            onClick={handleNext}
            className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/40 flex items-center justify-center transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FloorPlanSlider;
